export default __webpack_public_path__ + "static/media/work_blog-card.69e439fd.jpg";